import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useTaxAuthority, TaxAuthority } from './useData';
import {
  moduleConfig,
  getInitialFormData,
  mapItemToFormData,
} from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<TaxAuthority>
      useData={useTaxAuthority}
      config={{
        ...moduleConfig,
        getInitialFormData,
        mapItemToFormData,
      }}
    />
  );
};

export default Form;
